import * as React from 'react';

interface Props {
  width?: string;
}

const Icon: React.FC<Props> = ({ width = '14' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={width} fill="none" viewBox="0 0 12 12">
    <path stroke="#CCC" strokeLinecap="round" strokeLinejoin="round" d="M11 1.5H1l4 4.73V9.5l2 1V6.23z"></path>
  </svg>
);

export default Icon;
